<template>
	<el-row :gutter="20">
		<el-col :span="12">
			<span>申请人 ：</span>
			<span>{{row.username}}</span>
		</el-col>
		<el-col :span="12">
			<span>上门时间 ：</span>
			<span>{{setTime(row.visitStartTime)}}</span>
		</el-col>
		<el-col :span="12">
			<span>房间号 ：</span>
			<span>{{row.roomNumber}}</span>
		</el-col>
		<el-col :span="12">
			<span>联系电话 ：</span>
			<span>{{row.phone}}</span>
		</el-col>
		<el-col :span="12">
			<span>申请时间 ：</span>
			<span>{{setTime(row.createTime)}}</span>
		</el-col>
		<el-col :span="12">
			<span>备注 ：</span>
			<span>{{row.leaveMessage}}</span>
		</el-col>


		<el-col :span="24">
			<span style="display: flex;align-items: center;">照片 ：</span>
			<!-- <div v-for="s in row.showPathList" >
				<img  :src="s" alt=""  width="20%">
			</div> -->
			<img :src="row.fileName" width="20%">
		</el-col>
		
	</el-row>
</template>

<script>
	export default{
		props:["row"]
	}
</script>

<style>
</style>
